const ADD_EMAIL = 'ADD_EMAIL';
const ADD_NAME = 'ADD_NAME';
const SAVE_SCORE = 'SAVE_SCORE';
const RESET_SCORE = 'RESET_SCORE';

export { ADD_EMAIL, ADD_NAME, SAVE_SCORE, RESET_SCORE };
